export const getTotalSpentTime = (start: string, end: string): string => {
    // Parse start and end times manually

    if (end === undefined) {
      return "00:00:00";
    }

    const parseTime = (time: string): Date => {
      const [timePart, modifier] = time.split(" ");
      let [hours, minutes, seconds] = timePart.split(":").map(Number);
      if (modifier?.toLowerCase() === "pm" && hours < 12) {
        hours += 12; // Convert PM to 24-hour format
      } else if (modifier?.toLowerCase() === "am" && hours === 12) {
        hours = 0; // Handle 12 AM edge case
      }

      const date = new Date();
      date.setHours(hours, minutes, seconds || 0, 0);
      return date;
    };

    const startDate = parseTime(start);
    const endDate = parseTime(end);
    console.log("startDate ", startDate);
    // Difference in milliseconds
    const diffInMilliseconds = endDate?.getTime() - startDate?.getTime();

    // Convert milliseconds to total seconds
    const totalSeconds = Math.floor(diffInMilliseconds / 1000);

    const hours = Math.floor(totalSeconds / 3600)
      .toString()
      .padStart(2, "0");
    const minutes = Math.floor((totalSeconds % 3600) / 60)
      .toString()
      .padStart(2, "0");
    const seconds = (totalSeconds % 60).toString().padStart(2, "0");

    return `${hours}:${minutes}:${seconds}`;
  };
